/* Store locator - Show All Stores Only
--------------------------------------*/

class StoreLocator {
  constructor(parent) {
    if (!parent) return;

    this.parent = parent;
    this.init();
  }

  fetchStores = async () => {
    const url = this.parent.dataset.id;
    if (!url) return;

    try {
      const response = await fetch(url);
      const stores = await response.json();

      this.renderData(stores);

    } catch (error) {
      console.error("Error fetching store data:", error);
    }
  };

  renderData = (stores) => {
    console.log(stores);
    const wrapper = this.parent.querySelector('.state-city-blocks-wrapper-js');
    if (!wrapper) return;

    if (!stores || stores.length === 0) {
      wrapper.innerHTML = '<p class="store-location-empty">No stores available</p>';
      return;
    }

    let html = '<div class="store-location-grid">';
    stores.forEach(store => { html += this.storeHtml(store); });
    html += '</div>';

    wrapper.innerHTML = html;
  };

  textWithIconItem = (iconSvg, text) =>
    `<div class="text-with-icons__item snap-center" role="group">
      <div class="icon-block rounded-full text-custom store-location-icon-block" style="--text-color: 245 192 86;">
        ${iconSvg}
      </div>
      <div class="text-with-icons__text-wrapper">
        <div class="prose"><p>${text}</p></div>
      </div>
    </div>`;

  storeHtml = (store) => {
    const phone = store.phone_number || "";
    const timing = store.store_timing || "";
    const managerName = store.store_manager || "";

    const locationIcon = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" class="store-location-icon-svg"><path d="M12 2C8.13 2 5 5.13 5 9C5 14.25 12 22 12 22C12 22 19 14.25 19 9C19 5.13 15.87 2 12 2ZM12 11.5C10.62 11.5 9.5 10.38 9.5 9C9.5 7.62 10.62 6.5 12 6.5C13.38 6.5 14.5 7.62 14.5 9C14.5 10.38 13.38 11.5 12 11.5Z" fill="black"/></svg>`;
    const phoneIcon = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" class="store-location-icon-svg"><path d="M20.01 15.38C18.78 15.38 17.59 15.18 16.48 14.82C16.13 14.7 15.74 14.79 15.47 15.06L13.9 17.03C11.07 15.68 8.42 13.13 7.01 10.2L8.96 8.54C9.23 8.26 9.31 7.87 9.2 7.52C8.83 6.41 8.64 5.22 8.64 3.99C8.64 3.45 8.19 3 7.65 3H4.19C3.65 3 3 3.24 3 3.99C3 13.28 10.73 21 20.01 21C20.72 21 21 20.37 21 19.82V16.37C21 15.83 20.55 15.38 20.01 15.38Z" fill="black"/></svg>`;
    const timeIcon = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" class="store-location-icon-svg"><path d="M11.99 2C6.47 2 2 6.48 2 12C2 17.52 6.47 22 11.99 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 11.99 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20ZM12.5 7H11V13L16.25 16.15L17 14.92L12.5 12.25V7Z" fill="black"/></svg>`;
    const managerIcon = `
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
      xmlns="http://www.w3.org/2000/svg" aria-hidden="true"
      class="store-location-icon-svg">
      <path d="M12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12ZM12 14C9.33 14 4 15.34 4 18V20H20V18C20 15.34 14.67 14 12 14Z"
      fill="black"/>
    </svg>`;
    const addressRow = this.textWithIconItem(locationIcon, store.address || "");
    const phoneRow = phone ? this.textWithIconItem(phoneIcon, phone) : "";
    const timeRow = timing ? this.textWithIconItem(timeIcon, timing) : "";
    const managerRow = managerName ? this.textWithIconItem(managerIcon, managerName) : "";
    const mapLink = store.map_link
      ? `<a class="button store-location-get-direction btn btn--tertiary" target="_blank" rel="noopener" href="${store.map_link}" style="--button-background: 245 192 86 / var(--button-background-opacity, 1);--button-outline-color: 245 192 86;--button-text-color: 26 26 26;">Get Direction</a>`
      : "";

    return `
    <div class="store-info-container">
    <div class="store-info-contain-wrapper">
      <div class="state-icon-name-wrapper">
        <div class="store-state-icon">
          <img src="${store.state_image}">        
        </div>
        <div class="store-location-state-name">
          <p>${store.city}</p>
        </div>
      </div>
      <div class="multi-column__item-inner rounded store-location-card">
        <div class="column-content text-start">
          <p class="h4">${store.store_name || ""}</p>
          ${addressRow}
          ${phoneRow}
          ${timeRow}
          ${managerRow}
        </div>
        <div class="button-div">${mapLink ? `<div class="prose"><div>${mapLink}</div></div>` : ""}</div>
      </div>
      </div>
    </div>
    `;

  };


  init = () => {
    this.fetchStores();
  };
}



document.querySelectorAll('.store-location-wrapper-js').forEach((node) => {
  new StoreLocator(node);
});
